import React from 'react'

const Footer = () => {
    return (
        <>
            <footer className="page-footer">
                <p className="mb-0">Copyright © 2026. All right reserved.</p>
            </footer>
        </>
    )
}

export default Footer